import React, { useEffect, useState } from "react";
import SidebarItem from "./SidebarItem"; // Import the reusable component
import { useAuth } from "../context/AuthContext";

const Sidebar = () => {
  const [activeMenu, setActiveMenu] = useState(null);
  const { user } = useAuth();

  if (!user) {
    return null;
  }
  let sidebarMenu = [
    {
      name: "Dashboard",
      url: "/dashboard",
      icon: "fa-solid fa-house",
    },
    {
      name: "Folders",
      icon: "fa-solid fa-folder-open",
      submenu: [
        {
          name: "Shared Folders",
          url: "/shared-folders",
          icon: "fa-solid fa-user-group",
          activemenu: ["/folder-details"],
        },
        {
          name: "Personal Folders",
          url: "/personal-folders",
          icon: "fa-solid fa-user",
        },
        {
          name: "Favorites",
          url: "/favorite-folders",
          icon: "fa-solid fa-star",
        },
      ],
    },
    {
      name: "People",
      icon: "fa-solid fa-users",
      submenu: [
        {
          name: "Browse Users",
          url: "/browse-users",
          icon: "fa-solid fa-user",
        },
        {
          name: "Browse Clients",
          url: "/browse-clients",
          icon: "fa-solid fa-user",
          activemenu: ["/create-clients", "/edit-client"],
        },
      ],
    },

    {
      name: "Settings",
      icon: "fa-solid fa-gears",
      submenu: [
        {
          name: "Email Setting",
          url: "/email-settings",
          icon: "fa-solid fa-cog",
        },
        {
          name: "Personal Setting",
          url: "/personal-settings",
          icon: "fa-solid fa-user",
        },
        {
          name: "File Setting",
          url: "/file-settings",
          icon: "fa-solid fa-user",
        },
      ],
    },
    {
      name: "Messages",
      url: "/browse-messages",
      icon: "fa-solid fa-envelope",
    },
  ];

  if (user?.user_role === "CLIENT") {
    sidebarMenu = sidebarMenu.map((item) => {
      // Filter "Folders" submenu
      if (item.name === "Folders") {
        return {
          ...item,
          submenu: item.submenu.filter((sub) =>
            ["Shared Folders", "Favorites"].includes(sub.name)
          ),
        };
      }

      // Filter "Settings" submenu
      if (item.name === "Settings") {
        return {
          ...item,
          submenu: item.submenu.filter((sub) =>
            ["Personal Setting"].includes(sub.name)
          ),
        };
      }

      return item;
    });

    // Final cleanup: Only show menu items if their submenu has items
    sidebarMenu = sidebarMenu.filter((item) => {
      if (["Folders", "Settings"].includes(item.name)) {
        return item.submenu?.length > 0;
      }
      // Show only specific main sections for clients
      return ["Dashboard", "Folders", "Settings"].includes(item.name);
    });
  } else if(user?.user_role === "ADMIN") {
    // For admin users, show all menu items
    sidebarMenu = sidebarMenu.map((item) => {
      if (item.name === "People") {
        return {
          ...item,
          submenu: item.submenu.filter((sub) => sub.name !== "Browse Users"),
        };
      }
      if (item.name === "Settings") {
        return {
          ...item,
          submenu: item.submenu.filter((sub) => sub.name !== "Personal Setting"),
        };
      }
      return item;
    });

  } else {
    // For other user roles, remove "Personal Setting" from the "Settings" submenu
    sidebarMenu = sidebarMenu.map((item) => {
      if (item.name === "Settings") {
        return {
          ...item,
          submenu: item.submenu.filter((sub) => sub.name !== "Personal Setting"),
        };
      }
      return item;
    });
  }

  // console.log("user_role:", user?.user_role);
  // console.log("sidebarMenu (final):", sidebarMenu);
  

  return (
    <aside className="left_pannel">
      <div className="let_pannel_inner">
        <div className="accordion accordion-flush">
          {sidebarMenu.map((item, index) => (
            <SidebarItem
              key={index}
              item={item}
              activeMenu={activeMenu}
              setActiveMenu={setActiveMenu}
            />
          ))}
        </div>
      </div>
    </aside>
  );
};

export default Sidebar;
